<template>
  <div>
    <v-app-bar app id="navBar" dark flat class="darken-3">
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        v-if="mobile && $store.state.admin != '' && $route.name != 'login'"
      ></v-app-bar-nav-icon>
      <div class="d-flex align-center">
        <v-toolbar-title class="mt-2">Admin Portal</v-toolbar-title>
      </div>

      <v-spacer></v-spacer>

      <v-btn
        small
        @click="
          $store.dispatch('loginAdmin', '');
          $router.push({ name: 'login' });
        "
        text
        v-if="$store.state.admin != '' && $route.name != 'login'"
      >
        <span class="text-capitalize mr-2">logout</span>
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer
      width="auto"
      v-if="mobile && $store.state.admin != '' && $route.name != 'login'"
      app
      v-model="drawer"
      class=""
      id="navDrawer"
    >
      <div class="pl-8 mt-10 mr-5">
        <v-layout row wrap>
          <v-flex xs3>
            <span> <v-avatar size="28" class="" color="grey"> </v-avatar></span>
          </v-flex>
          <v-flex xs5 class="pt-1 pl-1">
            <span dark class="white--text">Gofere.com</span>
          </v-flex>
        </v-layout>
      </div>
      <br />
      <v-divider class="grey"></v-divider>
      <v-list nav dense class="pt-5">
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item
            class="white--text mb-4"
            @click="
              $router
                .push({
                  name: 'home',
                })
                .catch((err) => {})
            "
          >
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3">home</v-icon>
              <span style="font-size: 14px">Dashboard</span></v-list-item-title
            >
          </v-list-item>
          <v-list-item class="white--text mb-4">
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3"
                >monetization_on</v-icon
              >
              <span style="font-size: 14px">Orders</span></v-list-item-title
            >
          </v-list-item>

          <v-list-item class="white--text mb-4">
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3"
                >repeat_on
              </v-icon>
              <span style="font-size: 14px">UI</span></v-list-item-title
            >
          </v-list-item>

          <v-list-item
            class="white--text mb-4"
            @click="
              $router
                .push({
                  name: 'categories',
                })
                .catch((err) => {})
            "
          >
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3">laptop </v-icon>
              <span style="font-size: 14px">Categories</span></v-list-item-title
            >
          </v-list-item>
          <v-list-item class="white--text mb-4">
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3"
                >bar_chart
              </v-icon>
              <span style="font-size: 14px">Products</span></v-list-item-title
            >
          </v-list-item>
          <v-list-item class="white--text mb-4">
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3">save </v-icon>
              <span style="font-size: 14px"
                >Trendy Items</span
              ></v-list-item-title
            >
          </v-list-item>

          <v-list-item class="white--text mb-4">
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3">group </v-icon>
              <span style="font-size: 14px">Users</span></v-list-item-title
            >
          </v-list-item>

          <v-list-item class="white--text mb-4">
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3">message </v-icon>
              <span style="font-size: 14px">Messages</span></v-list-item-title
            >
          </v-list-item>

          <v-list-item class="white--text mb-4">
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3">lock </v-icon>
              <span style="font-size: 14px"
                >Privacy Center</span
              ></v-list-item-title
            >
          </v-list-item>

          <v-list-item class="white--text mb-4">
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3">help </v-icon>
              <span style="font-size: 14px">Help</span></v-list-item-title
            >
          </v-list-item>

          <v-list-item class="white--text mb-4">
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3">person </v-icon>
              <span style="font-size: 14px">About Us</span></v-list-item-title
            >
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-navigation-drawer
      width="200"
      v-if="!mobile && $store.state.admin != '' && $route.name != 'login'"
      permanent
      app
      v-model="drawer1"
      id="navDrawer"
    >
      <div class="pl-8 mt-10 mr-5">
        <v-layout row wrap>
          <v-flex xs3>
            <span> <v-avatar size="28" class="" color="grey"> </v-avatar></span>
          </v-flex>
          <v-flex xs5 class="pt-1 pl-1">
            <span dark class="white--text">Gofere.com</span>
          </v-flex>
        </v-layout>
      </div>
      <br />
      <v-divider class="grey"></v-divider>
      <v-list nav dense class="pt-5">
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item
            class="white--text mb-4"
            @click="
              $router
                .push({
                  name: 'home',
                })
                .catch((err) => {})
            "
          >
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3">home</v-icon>
              <span style="font-size: 14px">Dashboard</span></v-list-item-title
            >
          </v-list-item>
          <v-list-item
            class="white--text mb-4"
            @click="
              $router
                .push({
                  name: 'orders',
                })
                .catch((err) => {})
            "
          >
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3"
                >monetization_on</v-icon
              >
              <span style="font-size: 14px">Orders</span></v-list-item-title
            >
          </v-list-item>

          <v-list-item
            class="white--text mb-4"
            @click="
              $router
                .push({
                  name: 'ui',
                })
                .catch((err) => {})
            "
          >
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3"
                >repeat_on
              </v-icon>
              <span style="font-size: 14px">UI</span></v-list-item-title
            >
          </v-list-item>

          <v-list-item
            class="white--text mb-4"
            @click="
              $router
                .push({
                  name: 'categories',
                })
                .catch((err) => {})
            "
          >
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3">laptop </v-icon>
              <span style="font-size: 14px">Categories</span></v-list-item-title
            >
          </v-list-item>
          <v-list-item
            class="white--text mb-4"
            @click="
              $router
                .push({
                  name: 'products',
                })
                .catch((err) => {})
            "
          >
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3"
                >bar_chart
              </v-icon>
              <span style="font-size: 14px">Products</span></v-list-item-title
            >
          </v-list-item>
          <v-list-item
            class="white--text mb-4"
            @click="
              $router
                .push({
                  name: 'trendy',
                })
                .catch((err) => {})
            "
          >
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3">save </v-icon>
              <span style="font-size: 14px"
                >Trendy Items</span
              ></v-list-item-title
            >
          </v-list-item>

          <v-list-item
            class="white--text mb-4"
            @click="
              $router
                .push({
                  name: 'users',
                })
                .catch((err) => {})
            "
          >
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3">group </v-icon>
              <span style="font-size: 14px">Users</span></v-list-item-title
            >
          </v-list-item>

          <v-list-item
            class="white--text mb-4"
            @click="
              $router
                .push({
                  name: 'blog',
                })
                .catch((err) => {})
            "
          >
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3"
                >language
              </v-icon>
              <span style="font-size: 14px">Blog</span></v-list-item-title
            >
          </v-list-item>

          <v-list-item class="white--text mb-4">
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3">lock </v-icon>
              <span style="font-size: 14px"
                >Privacy Center</span
              ></v-list-item-title
            >
          </v-list-item>

          <v-list-item class="white--text mb-4">
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3">help </v-icon>
              <span style="font-size: 14px">Help</span></v-list-item-title
            >
          </v-list-item>

          <v-list-item class="white--text mb-4">
            <v-list-item-title
              ><v-icon class="mr-2 grey--text text--lighten-3">person </v-icon>
              <span style="font-size: 14px">About Us</span></v-list-item-title
            >
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      drawer: false,
      drawer1: false,
      group: null,
    };
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
  },
  watch: {
    group() {
      this.drawer = false;
    },
  },
};
</script>
<style scoped>
#navBar,
#navDrawer {
  background-color: rgba(31, 31, 31, 255);
}

v-list-item {
  margin-top: 10px;
}
</style>
